<template>
  <div class="home">
   <div>
      <div>
        <div class="col-md-12 col-lg-12 col-xxl-12">
            <Menu :empty="notnull" />
            <div class="container p-0 mt-0 min-vh-100">
              <div v-if="!$route.params.data">
                <template v-if="!notnull">
                    <div class="d-flex flex-column justify-content-center align-items-center vh-100" v-if="$store.getters.authenticated">
                        <small class="">Carregando...</small>
                    </div> 
                </template>
                <template v-else>
                  <div class="d-flex flex-column justify-content-center align-items-center vh-100" v-if="$store.getters.authenticated">
                      <h4 class="text-center ">Você não cadastrou nenhuma obra!</h4>
                      <h4 class="text-center "><span class="addObra cursor-pointer fw-bold" data-bs-toggle="modal" data-bs-target="#addData">Clique aqui</span> para cadastrar</h4>
                  </div> 
                  <div class="d-flex flex-column justify-content-center align-items-center vh-100" v-else>
                      <h4 class="text-center">Caro cliente, nenhum registro foi encontrado!</h4>
                      <h4 class="text-center">Tente novamente mais tarde.</h4>
                  </div>
                </template>
                
              </div>
                
              <router-view v-else />
                
            </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="addData" v-if="$store.getters.authenticated">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Nova Atualização de Obra</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="construction" class="form-label">Data:</label>
                    <input type="date" :value="setInputDate()" class="form-control" id="novaObraData">
                </div>
                <small class="text-warning" id="retornoNovaObra"></small>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" @click="novaObra">Cadastrar</button>
            </div>
            </div>
        </div>
    </div> 
    <footer class="text-center py-6 mt-10" style="background-color: #5C452B;">
    <div class="text-white text-sm">
      <p class="mb-1">Blend Pituba</p>
      <p class="text-xs text-gray-300">
        © {{ new Date().getFullYear() }} Blend Pituba. Todos os direitos reservados.
      </p>
    </div>
  </footer>
  </div>
  

</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue';
import Cookies from "js-cookie";
export default {
  name: 'Home',
  components: {
    Menu
  },
  data() {
    return {
      notnull: false,
    }
  },
  
  mounted() {
    if (this.$route.params && this.$route.params.data) {
       document.title = `Blend Pituba - Andamento da Obra - ${this.$route.params.data.replace('-', '/')}`;
       if(this.checarData(this.$route.params.data) ){
         this.redirect(true);
       }
    }else{
      this.redirect(false);
    }
   
  },
  methods: {
    checarData(data) {
      return data instanceof Date && !isNaN(data);
    },
    async redirect(bool){
      if(!bool){
        await fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_LATDATE.replace('{id}', process.env.VUE_APP_ENV_EMPREENDIMENTOID)}`, {
            method: 'GET',
        }).then(response => response.json())
        .then(res => {
            
            if(res.date){
                this.$router.push({ name: 'DataFilter', params: { data: res.date } }) 
            }else{
              this.notnull = true;
            }
            
        })
       }else{
        this.$router.push({ name: 'DataFilter', params: { data: this.$route.params.data} }) 
       }
    },
    setInputDate(){
        var hoy = new Date();
        var d = hoy.getDate();
        var m = hoy.getMonth()+1;
        var y = hoy.getFullYear();

        if(d < 10)
            d = "0"+d;

        if(m < 10)
            m = "0"+m;

        var data = y+"-"+m+"-"+d;
        return data;
    },
    novaObra(){
      const date = document.getElementById('novaObraData').value;

      const verif = this.$store.getters.datas.enterprise.constructionscolumn.findIndex(c => c.date === date);

      if(verif == -1){
          
          var token = Cookies.get('_mysapp_token');

          fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_CREATE.replace('{id}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{date}', date)}`, {
          method:'POST',
          headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization' : 'Bearer ' + token
          }
          })
          .then((response) => response.json())
          .then((data) => {
              if(data.created == 'ok'){
                  this.closeModal('addData');
                  this.$store.dispatch('fetchData');
                  this.$router.push(`/${date}`);
              }else{
                alert('Não foi possível adicionar uma nova data. Tente novamente mais tarde.');
                document.location.reload();
              }
          })
          .catch((err) => console.error(err));

      }else{
          const retorno = document.getElementById('retornoNovaObra');
          retorno.innerText = 'Esta data já foi cadastrada!';
          setTimeout(() => {
          retorno.innerText = '';
          }, 2500)
      }
    },
    closeModal(modl){
      const modal = document.getElementById(modl);
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.querySelector('.modal-backdrop').remove();

      const body = document.querySelector('body');
      body.classList.remove('modal-open');
      body.style.overflow="auto";
    },
  }

}
</script>
<style scoped>
  
  .edit-banner{
    position: absolute;
    top: 10px;
    left: 10px;
    display: none;
  }
  .img-banner:hover .edit-banner{
    display: block;
  }
  .data-remove{
    position: absolute;
    top: -3px;
    right: -3px;
    display: none;
  }
  .router-link:hover .data-remove{
    display: block;
  }
  .addObra{
    text-decoration: underline;
  }
</style>
